import React, { useState, useEffect } from "react";

import {
    Box,
    Button,
    ButtonGroup,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    MobileStepper,
    Modal,
    Paper,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

import tableIcons from "../tableFormatting/tableIcons";

import nanoCompLanding from "../../images/wizardHelp/contentCreator/nanoCompLanding.png"
import nanoCompCreation from "../../images/wizardHelp/contentCreator/nanoCompCreation.png"
import nanoCompVis from "../../images/wizardHelp/contentCreator/nanoCompVis.png"
import nanoCompVisEdit from "../../images/wizardHelp/contentCreator/nanoCompVisEdit.png"
import nanoCompDescriptions from "../../images/wizardHelp/contentCreator/nanoCompDescriptions.png"
import nanoCompAdditionalMaterial from "../../images/wizardHelp/contentCreator/nanoCompAdditionalMaterial.png"
import nanoCompQuizzes from "../../images/wizardHelp/contentCreator/nanoCompQuizzes.png"
import nanoCompEssays from "../../images/wizardHelp/contentCreator/nanoCompEssays.png"
import nanoCompFeedback from "../../images/wizardHelp/contentCreator/nanoCompFeedback.png"

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);


const images = [
  {
    label: "Steps 1 & 2",
    title: "Content Creation",
    imgPath: nanoCompLanding,
    description: ["1: Please Navigate to NanoCompetenices", "2: Click the Green + button at the top of the page"],
  },
  {
    label: "Steps 3 & 4",
    title: "Content Creation",
    imgPath: nanoCompCreation,
    description: ["3: Upload document as .pdf or .docx", "4: Click submit and let the Artificial Intelligence do the work!"],

  },
  {
    label: "Steps 5",
    title: "Visualisation Analysis",
    imgPath: nanoCompVis,
    description: ["5: Navigate to your newly created content", "You will find a Force-Directed Tree Map"],

  },
  {
    label: "Steps 5",
    title: "Visualisation Analysis",
    imgPath: nanoCompVis,
    description: ["The size of the node reflects it's relevance", "The size of the connecting line represents it's stength to the connecting node"],

  },
  {
    label: "Steps 6 & 7",
    title: "Visualisation Editing",
    imgPath: nanoCompVisEdit,
    description: ["6: Click Edit Study Map", "7: Choose Which Node you would like to adjust"],

  },
  {
    label: "Steps 8",
    title: "Visualisation Editing",
    imgPath: nanoCompVisEdit,
    description: ["8: Click Publish changes", "All changes will be saved to the database"],

  },
  {
    label: "Steps 9 & 10",
    title: "Study Content Editing",
    imgPath: nanoCompDescriptions,
    description: ["9: Click Edit Study Content", "10: Select which parent Node to edit descriptions"],

  },
  {
    label: "Steps 11 & 12",
    title: "Additional Materials",
    imgPath: nanoCompAdditionalMaterial,
    description: ["11: Feel free to edit the descriptions of each Node", "12: Additional Materials can be added as Links, Photos and Videos"],

  },
  {
    label: "Steps 13 & 14",
    title: "Quizzes",
    imgPath: nanoCompQuizzes,
    description: ["13: Select the Quiz button", "14: Decide how the student will answer the question (Node, Write or Rate). Write the question."],

  },
  {
    label: "Steps 15",
    title: "Quizzes",
    imgPath: nanoCompQuizzes,
    description: ["15: Fill out the relevant answer(s).", "Click the green tick before moving on. Publish all changes once you are happy with the content."],

  },
  {
    label: "Steps 16 & 17",
    title: "Essays",
    imgPath: nanoCompEssays,
    description: ["16: Click on the Essay button.", "17: Fill out the topic and theme of the essay. Please remember to click the green tick before moving on."],

  },
  {
    label: "Steps 18 & 19",
    title: "Feedback",
    imgPath: nanoCompFeedback,
    description: ["18: Click on the Feedback button.", "19: Write a question for the student to answer regarding their experiences."],

  }
];

const CreatorWizard = () => {

    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = images.length;
  
    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
  
    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
  
    const handleStepChange = (step) => {
      setActiveStep(step);
    };

return (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justify="center"
  >
    <div style={{ padding: "20px 0 0 0", textAlign: "center" }}>
          
      <>
        <h2 style={{ marginBottom: "20px", marginTop: "-30px" }}>
          {images[activeStep].title}      
        </h2>
        
        </>
          <Paper
            square
            elevation={0}
            sx={{
              display: 'flex',
              alignItems: 'center',
              textAlign: "center",
              height: 50,
              pl: 2,
              bgcolor: 'background.default',
            }}
          />
                 
            <SwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={activeStep}
              onChangeIndex={handleStepChange}
              enableMouseEvents
            >
              {images.map((step, index) => (
                <div key={step.label}>
                  {Math.abs(activeStep - index) <= 21 ? (
                    <Box
                      component="img"
                      sx={{
                        minWidth: "50%",
                        maxWidth: "100%",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        textAlign: "center",
                        imageRendering: "high-quality"
                      }}
                      src={step.imgPath}
                      alt={step.label}
                    />
                  ) : null}
                  </div>
              ))}
              </SwipeableViews>
                      
              <MobileStepper
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    Next
                    {theme.direction === 'rtl' ? (
                      <tableIcons.KeyboardArrowLeft />
                      ) : (
                      <tableIcons.KeyboardArrowRight />
                      )}
                  </Button>
                  }
                  backButton={
                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                      {theme.direction === 'rtl' ? (
                        <tableIcons.KeyboardArrowRight />
                        ) : (
                        <tableIcons.KeyboardArrowLeft />
                        )}
                      Back
                    </Button>
                  }
              />
              
              <div style={{ marginBottom: "-20px" }}>
                {images[activeStep].description.map((d, i) => (
                  <>
                    <p>{d}</p>
                  </>
                ))}
              </div>
      </div>
  </Grid>


  )
};


export default CreatorWizard;